import _extends from '@babel/runtime/helpers/extends';
import 'react';
import { jsx } from '@emotion/react';

function SvgMoonGlyph(props) {
  return jsx("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), jsx("path", {
    d: "M19.298 8.003a.574.574 0 0 0-.14.034C12.638 10.36 8 16.415 8 23.509 8 32.61 15.659 40 25.092 40c6.347 0 11.893-3.35 14.84-8.313a.521.521 0 0 0-.068-.61.577.577 0 0 0-.617-.15c-1.721.61-3.582.94-5.528.94-8.83 0-15.977-6.896-15.977-15.417 0-2.783.766-5.399 2.102-7.652a.524.524 0 0 0-.023-.557.552.552 0 0 0-.227-.19.576.576 0 0 0-.296-.048ZM18.172 9.65c-.977 2.076-1.545 4.374-1.545 6.8 0 9.102 7.66 16.492 17.092 16.492 1.545 0 3.02-.258 4.447-.628-2.887 3.984-7.648 6.61-13.074 6.61-8.83 0-15.977-6.895-15.977-15.415 0-6.122 3.708-11.37 9.057-13.86Z",
    fill: "currentColor"
  }));
}

export { SvgMoonGlyph as default };
